"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
const React = require("react");
const react_select_1 = require("react-select");
class Select extends React.Component {
    render() {
        const { ...rest } = this.props;
        return (React.createElement(react_select_1.default, Object.assign({ className: "react-select" }, rest)));
    }
}
exports.default = Select;
class MultiSelect extends React.Component {
    render() {
        const { ...rest } = this.props;
        return (React.createElement(react_select_1.default, Object.assign({ className: "react-select", isMulti: true }, rest)));
    }
}
exports.MultiSelect = MultiSelect;
